export type PortalHelpRole = 'apprenant' | 'formateur' | 'partenaire' | 'admin';

export type HelpSection = {
  id: string;
  title: string;
  icon: string;
  summary: string;
  steps: string[];
  tips?: string[];
  linkTo?: string;
  linkLabel?: string;
};

export type HelpFaq = {
  question: string;
  answer: string;
};

export type PortalHelpConfig = {
  pageTitle: string;
  pageDescription: string;
  roleLabel: string;
  intro: string;
  gettingStarted: { title: string; steps: string[] };
  sections: HelpSection[];
  faqs: HelpFaq[];
};

export const PORTAL_HELP_PATHS: Record<PortalHelpRole, string> = {
  apprenant: '/app/aide',
  formateur: '/formateur/aide',
  partenaire: '/partenaire/aide',
  admin: '/admin/aide',
};

export const PORTAL_PROFILE_PATHS: Partial<Record<PortalHelpRole, string>> = {
  apprenant: '/app/profil',
  formateur: '/formateur/profil',
  admin: '/admin/profile',
};

export function resolvePortalHelpPath(pathname: string): string | null {
  if (pathname.startsWith('/app')) return PORTAL_HELP_PATHS.apprenant;
  if (pathname.startsWith('/formateur')) return PORTAL_HELP_PATHS.formateur;
  if (pathname.startsWith('/partenaire')) return PORTAL_HELP_PATHS.partenaire;
  if (pathname.startsWith('/admin')) return PORTAL_HELP_PATHS.admin;
  return null;
}

export function resolvePortalProfilePath(pathname: string): string | null {
  if (pathname.startsWith('/app')) return PORTAL_PROFILE_PATHS.apprenant ?? null;
  if (pathname.startsWith('/formateur')) return PORTAL_PROFILE_PATHS.formateur ?? null;
  if (pathname.startsWith('/admin')) return PORTAL_PROFILE_PATHS.admin ?? null;
  return null;
}
